import AppModel from "../../../../../../../shared/src/ranj/app/core/AppModel";
import AbstractView from "../../../../../../../shared/src/ranj/equalture/view/AbstractView";

export default class BalloonView extends AbstractView {

    constructor(target) {
        super(target);
        this._textfield = this._target.bodyTextfield;
        this._speedFactor = AppModel.speedFactor;
    }

    get target() {
        return this._target;
    }
    
    setText(text, animate) {
        this._textfield.text = text;
        if (animate) {
            const target = this._target;
            target.alpha = 0;
            if (!target.scaleOrig) {
                target.scaleOrig = target.scaleX;
            }
            target.scaleX = target.scaleY = .95 * target.scaleOrig;
            const duration = 400 / this._speedFactor;
            createjs.Tween.get(target).to({ alpha: 1, scaleX:target.scaleOrig, scaleY:target.scaleOrig }, duration, createjs.Ease.quadOut);
        }
    }

    /**
     * @param value {Boolean}
     */
    set visible(value) {
        this._target.visible = value;
    }

    get visible() {
        return this._target.visible;
    }
}
